var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    constructor() {
        super(...arguments);
        // 表单类型
        // @Inject({ default: "" }) readonly formType;
        this.imageUrl = '';
        this.previewUrl = '';
        this.previewVisible = false;
        this.fileList = [];
    }
    get action() {
        if (this._fieldProps.actionPath) {
            return `${this.AppConfig.development ? '' : this.AppConfig.target}${this._fieldProps.actionPath}`;
        }
    }
    get icon() {
        return this._fieldProps.icon || 'plus';
    }
    get headers() {
        return {
            token: this.$Store.System.AccessToken,
        };
    }
    get max() {
        return lodash.get(this._fieldProps, 'max', 1);
    }
    get value() {
        return lodash.get(this.formState, this._name);
    }
    set value(value) {
        lodash.set(this.formState, this._name, value);
    }
    get isPlusBottun() {
        return (!(this.disabled || this._readonly) && this.fileList.length < this.max);
    }
    get message() {
        return lodash.get(this._fieldProps, 'message', false);
    }
    get accept() {
        return lodash.get(this._fieldProps, 'accept', 'image/*');
    }
    get uploadText() {
        return lodash.get(this._fieldProps, 'uploadText', 'Upload');
    }
    async mounted() {
        // this.onRequest();
        if (this.value) {
            this.imageUrl = this.value;
        }
        if (this.value && !this.fileList.length) {
            this.fileList = [
                {
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: this.value,
                },
            ];
        }
        if (this.debug) {
            console.log('');
            console.group(`Field ~ ${this.entityKey} ${this._name} `);
            console.log(this);
            console.groupEnd();
        }
    }
    beforeUpload(file) {
        return new Promise(async (resolve, reject) => {
            const maxSize = this._fieldProps.maxSize;
            if (maxSize && file.size > maxSize) {
                this.$message.warning(`上传的图片超过最大限制`);
                return reject(false);
            }
            return resolve(true);
        });
    }
    onChange(event) {
        this.fileList = event.fileList;
        if (event.file.status === 'removed') {
            return (this.value = undefined);
        }
        if (event.file.status === 'uploading') {
            this.spinning = true;
        }
        else {
            this.spinning = false;
            if (event.file.status === 'done') {
                if (!event.file.response.data) {
                    this.$message.error(event.file.response.msg);
                    this.fileList = [];
                }
                else {
                    const src = lodash.get(event, 'file.response.data');
                    this.value = src;
                    lodash.set(this.formState, this._name, src);
                }
            }
        }
    }
    onValueChange(val, old) {
        if (val && !this.fileList.length) {
            this.fileList = [
                {
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: val,
                },
            ];
        }
    }
    // 预览
    handlePreview(file) {
        this.previewUrl = lodash.has(file, 'url') ? file.url : file?.response?.data;
        this.previewVisible = true;
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "onValueChange", null);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}
